import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    q: "Como funcionam as explicações no Instituto Leopoldo Guimarães?",
    a: "Oferecemos explicações individuais (1 para 1) e em pequenos grupos (até 4 alunos), sempre adaptadas ao nível e ritmo do aluno. Cada plano é construído após uma conversa de diagnóstico.",
  },
  {
    q: "O que são as salas de estudo?",
    a: "São espaços calmos, organizados e supervisionados, onde os alunos estudam de forma autónoma com apoio próximo dos nossos professores sempre que precisarem.",
  },
  {
    q: "Preparam para os exames nacionais?",
    a: "Sim. Trabalhamos os conteúdos, treinamos exames de anos anteriores e fazemos simulações cronometradas em todas as disciplinas-chave do secundário.",
  },
  {
    q: "Como funciona a preparação para os exames Cambridge?",
    a: "Ensinamos inglês com base na metodologia Cambridge e preparamos os nossos alunos para os exames internacionais — desde os Young Learners (A1) até C2 Proficiency — com materiais alinhados ao padrão oficial e simulações reais. Não somos um centro examinador, mas trabalhamos especificamente para que os alunos cheguem ao exame preparados e confiantes.",
  },
  {
    q: "O que são as sessões de coaching em PNL?",
    a: "Sessões individuais de coaching com base em Programação Neurolinguística (PNL), focadas em foco, confiança, gestão emocional, autoconhecimento e desempenho. Apoiam tanto o percurso académico como o desenvolvimento pessoal do aluno.",
  },
  {
    q: "Têm sessões de coaching e de PNL?",
    a: "Sim. Disponibilizamos sessões de coaching em Programação Neurolinguística (PNL), gestão emocional e desenvolvimento pessoal, conduzidas por uma coach certificada.",
  },
  {
    q: "O Instituto é uma entidade formadora certificada?",
    a: "Sim. O Instituto Leopoldo Guimarães é uma entidade formadora certificada pela DGERT, com formações nas áreas da saúde, desenvolvimento pessoal, educação e línguas. Emitimos certificados válidos no final de cada ação de formação.",
  },
  {
    q: "Que tipo de formações DGERT oferecem?",
    a: "Temos um leque diversificado de formações, com destaque para a área da saúde (cuidados a idosos e dependentes, primeiros socorros, higiene e segurança alimentar) e o desenvolvimento pessoal (inteligência emocional, comunicação, gestão de stress, liderança). Também desenhamos formações personalizadas para empresas, IPSS, lares e clínicas.",
  },
  {
    q: "Quais são os horários?",
    a: "Estamos abertos de segunda a sexta, das 07h30 às 19h00. Os horários das explicações são combinados de acordo com a disponibilidade do aluno.",
  },
  {
    q: "As aulas são presenciais?",
    a: "Sim. Todas as nossas aulas, explicações e sessões são em regime presencial, num ambiente premium e acolhedor — pensamos que o acompanhamento próximo faz toda a diferença.",
  },
];

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="section bg-white">
      <div className="container-tight">
        <div className="max-w-3xl mb-12">
          <div className="text-[11px] uppercase tracking-[0.22em] font-semibold text-bordeaux-700 mb-4">Perguntas Frequentes</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-stone-900 leading-tight">
            Tudo o que precisa <span className="italic text-bordeaux-700">de saber.</span>
          </h2>
        </div>

        <div className="max-w-3xl">
          <Accordion type="single" collapsible className="space-y-2">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border border-stone-200 rounded-2xl px-6 data-[state=open]:border-bordeaux-300 data-[state=open]:bg-bordeaux-50/30 transition-colors"
              >
                <AccordionTrigger className="text-left font-display text-lg sm:text-xl text-stone-900 hover:text-bordeaux-700 hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-stone-600 leading-relaxed pb-5 text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
